import { DatePicker } from '~/components/ui/date-picker'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type DateFieldProps = Omit<FieldProps, 'children' | 'error'> & { disabled?: boolean }

export function DateField({ label, id, optional, className, ...props }: DateFieldProps) {
  const field = useFieldContext<Date | null>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
    >
      <DatePicker
        mode="single"
        className="rounded-lg flex-row-reverse justify-between"
        selected={field.state.value ?? undefined}
        captionLayout="dropdown"
        onSelect={(date) => {
          field.handleChange(date ?? null)
        }}
        disabled={props.disabled}
      />
    </Field>
  )
}
